// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PCopyrightOutlinedSvg from "@fishx/icons-svg/es/asn/PCopyrightOutlined";
import FishxIcon from '../components/FishxIcon';

var PCopyrightOutlined = function PCopyrightOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PCopyrightOutlinedSvg
  }));
};

PCopyrightOutlined.displayName = 'PCopyrightOutlined';
export default React.forwardRef(PCopyrightOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PCopyrightOutlined.js
// module id = 3307
// module chunks = 0